import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";

export interface Profile {
  readonly avatar: string;
}

@Injectable()
export class ProfileService {

  constructor(private http: HttpClient) {
  }

  get(): Observable<Profile> {
    return this.http.get<Profile>('/profile');
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/profile.service.ts